import axios from "api/axios"
import { APIResponse, ConfigWithURLParams } from "api/types"
import { formatErrorResponse, formatSuccessResponse } from "api/utils"

import { UserCredentials, VerifiedCredential } from "./types"
import urls from "./urls"

export default {
  getAdmissionLetter: async ({
    urlParams,
  }: ConfigWithURLParams): Promise<APIResponse<UserCredentials>> => {
    try {
      const res = await axios.get(urls.getAdmissionLetter(urlParams.slug))
      return formatSuccessResponse(res)
    } catch (e) {
      throw formatErrorResponse(e)
    }
  },
  getUserCredentials: async ({
    urlParams: { itemType, itemId },
  }: ConfigWithURLParams): Promise<APIResponse<UserCredentials>> => {
    try {
      const res = await axios.get(urls.getUserCredentials(itemType, itemId))
      return formatSuccessResponse(res)
    } catch (e) {
      return formatErrorResponse(e)
    }
  },
  getCredentialBySerialNumber: async ({
    urlParams,
  }: ConfigWithURLParams): Promise<APIResponse<VerifiedCredential>> => {
    try {
      const res = await axios.get(
        urls.getCredentialBySerialNumber(urlParams.serialNumber)
      )
      return formatSuccessResponse(res)
    } catch (e) {
      throw formatErrorResponse(e)
    }
  },
}
